import { render, staticRenderFns } from "./EmotionCard.vue?vue&type=template&id=6d9b70b0&scoped=true&"
import script from "./EmotionCard.vue?vue&type=script&lang=js&"
export * from "./EmotionCard.vue?vue&type=script&lang=js&"
import style0 from "./EmotionCard.vue?vue&type=style&index=0&id=6d9b70b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b70b0",
  null
  
)

export default component.exports